<template>
  <div class="svg-outer">
    <Plan_svg />
    <input type="text" id="search" placeholder="Buscar..." />
  </div>
</template>

<style>
.svg-outer{
  position: relative;
}
#search {
  background: #fff;
  border: 0;
  position: absolute;
  top:702px;
  left: 699px;
  width: 180px;
  display: none;
}
#search:focus{
  outline: none;
}
</style>

<script>
import axios from "axios";
import $ from "jquery";
import Plan_svg from "@/views/building/Plan_svg";

export default {
  name: "LegacyGeneralPlan",
  components: { Plan_svg },
  data() {
    return {
      workplaces: [],
      scrollDatos: null,
      copyFeedbackTimeout: null
    };
  },

  mounted() {
    this.getWorkplaces();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("keydown", this.handleKeyDown);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("keydown", this.handleKeyDown);
    clearTimeout(this.copyFeedbackTimeout);
  },

  methods: {
    getWorkplaces() {
      let path = this.$store.state.endpoint + "/workplace";
      axios
        .get(path)
        .then(response => {
          this.workplaces = response.data;
          window.workplaces = response.data;
          window.fill_data = this.fill_data;
          window.isAdmin = this.isAdmin;
          this.initialize();
        })
        .finally(() => {
          let path =
            this.$store.state.endpoint +
            "/workplaceAssignation/last/" +
            this.$store.getters.user.person;
          axios.get(path).then(response => {
            if(response.data.workplace != null){
              let path =
                this.$store.state.endpoint +
                "/workplace/" +
                response.data.workplace;
              axios.get(path).then(response => {
                this.workplaces.find(
                  workplace => workplace.id === response.data.id
                ).host = response.data.host;
              });
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    initialize() {
      /* Remove unused elements and loading */
      if(this.isAdmin){
        $("[id=nbnf]").css("opacity", "1");
      }
      else{
        $("[id=nbnf]").css("opacity", "0");
      }
      $("[id=loading]").css("opacity", "0");
      $("[id=loading]").css("pointer-events", "none");
      if(window.isAdmin) $("#search").css("display", "block");
      /* Mouse interactions */
      $("[id^=mesa]").mouseenter(function() {
        if ($(this).attr("data-active") != "true") {
          $(this).css("stroke", "#ef7d10");
          $(this).css("cursor", "pointer");
          $(this).css("stroke-width", "4px");
        }
        if ($("[id^=mesa][data-active=true]").length > 0) return;
        window.fill_data(this);
      });
      $("[id^=mesa]").mouseout(function() {
        if ($(this).attr("data-active") != "true") {
          $(this).css("stroke", "#333");
          $(this).css("cursor", "default");
          $(this).css("stroke-width", "1px");
        }
        if ($("[id^=mesa][data-active=true]").length > 0) return;
        $("#placeholder,#placeholder_text,#placeholder_rect").css(
          "visibility",
          "visible"
        );
        window.hide_copy_buttons();
        $("#foto").css("opacity","0");
      });
      $("[id^=mesa]").click(function(e) {
        e.stopPropagation();
        $("[id^=mesa]").attr("data-active", "false");
        $("[id^=mesa]").each(function() {
          $(this).css("stroke", "#333");
          $(this).css("stroke-width", "1px");
        });
        $(this).attr("data-active", "true");
        $(this).css("stroke", "#ef7d10");
        $(this).css("stroke-width", "5px");
        window.fill_data(this);
        window.location.hash = $(this)
          .attr("id")
          .substr(5);
        // Put at the end to force full painting
        var p = $(this).parent();
        var el = $(this).clone(true, true);
        $(this).remove();
        el.appendTo(p);
        // Fix: put all circles on top of the rest
        $("circle[id^=n]").each(function() {
          var p = $(this).parent();
          var el = $(this).clone(true, true);
          $(this).remove();
          el.appendTo(p);
        });

      });
      $("text,#nodismiss").click(function(e) {
        e.stopPropagation();
      });

      if (window.isAdmin) {
        document.getElementById("search").addEventListener("keyup", function(event) {
          event.preventDefault();
          if (event.keyCode === 13) {
            $("#inputEnter").click();
          }
        });
        $("#inputEnter").click(function(e){
          e.stopPropagation();
          let search = document.getElementById("search").value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          if(search!=""){
            let coincidences_person = window.workplaces.filter(o => o.workplace_assignations.filter( p => (p.person.preferred_name.given_name + " " + p.person.preferred_name.family_name).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) >= 0).length>0)
            let coincidences_place = window.workplaces.filter(o => (o.file_cabinet + " " + o.network_socket + " " + o.extension + " " + o.place_code).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) >= 0)
            let coincidences_host = window.workplaces.filter(o => o.host !== null && (o.host.hostname + " " + o.host.mac + " " + o.host.ip).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) >= 0)
            let coincidences = coincidences_host.concat(coincidences_person).concat(coincidences_place).reduce((a,c) => a + c.place_code + " ", "").toLowerCase().replace("-","_").replace("ñ","nh")
            $("[id^=mesa]").each(function() {
              $(this).css("filter", "contrast(0.2) brightness(1.8)");
              var id = $(this)
              .attr("id")
              .replace(/mesa_/, "")
              .toLowerCase();
              if(coincidences.indexOf(id + " ") >= 0){
                $(this).css("filter", "drop-shadow(black 0px 0px 2px)");
                // Put at the end to force full painting
                var p = $(this).parent();
                var el = $(this).clone(true, true);
                $(this).remove();
                el.appendTo(p);
              }
            });
          }
          else{
            $("[id^=mesa]").each(function() {
              $(this).css("filter", "");
            });
          }
        });
      }
      else{
        $("#inputBox").css("opacity", "0");
        $("#text6221").css("opacity", "0");
        $("#path6331").css("opacity", "0");
      }
      $("div#main").click(function(e) {
        e.stopPropagation();
        window.location.hash = null;
        $("[id^=mesa]").attr("data-active", "false");
        $("[id^=mesa]").each(function() {
          $(this).css("stroke", "#333");
        });
        $("#placeholder,#placeholder_text,#placeholder_rect").css(
          "visibility",
          "visible"
        );
        window.hide_copy_buttons();
      });
      $("[id^=mesa]").each(function() {
        var id = $(this)
          .attr("id")
          .replace(/mesa_/, "")
          .toLowerCase();
        //console.log(`Looking for mesa ${id}...`);
        var workplace = window.workplaces.filter(
          o => o.place_code.toLowerCase().replace("-","_").replace("ñ","nh") == id
        )[0];
        //console.log(workplace);
        if (workplace === undefined) {
          //console.log(`Mesa ${id} not found?`);
          return;
        }
        workplace.workplace_assignations_before = workplace.workplace_assignations.filter(
          o => o.freed_status === true
        );
        workplace.workplace_assignations = workplace.workplace_assignations.filter(
          o => o.freed_status !== true
        );
        if (window.isAdmin) {
          // No photo indicator
          const assignedAccount = workplace.workplace_assignations.length === 1
            ? workplace.workplace_assignations[0].person.account
            : null;
          const hasPhoto = assignedAccount && assignedAccount.picture_website != null;
          const needsPhoto = workplace.workplace_assignations.length === 1 &&
            (!hasPhoto || assignedAccount.picture_website_temporary === true);
          $(`[id=nf_${id}]`).css("opacity", needsPhoto ? "1" : "0");
          // No bio indicator
          if (workplace.workplace_assignations.length != 1 || (workplace.workplace_assignations[0].person.publicprofile != null && workplace.workplace_assignations[0].person.publicprofile.text_website != null && ! Object.values(workplace.workplace_assignations[0].person.publicprofile.text_website).every(x => x === null || x === ''))){
            $(`[id=nb_${id}]`).css("opacity", "0");
          }
          else{
            $(`[id=nb_${id}]`).css("opacity", "1");
          }
          // Table color
          if (
            workplace.workplace_assignations !== undefined &&
            workplace.workplace_assignations.length > 0
          ) {
            var wa = workplace.workplace_assignations[0];
            if (
              wa.expiration_date !== undefined &&
              wa.expiration_date !== null
            ) {
              var daysleft =
                (Date.parse(wa.expiration_date) - Date.now()) /
                (1000 * 3600 * 24);
              if(workplace.workplace_assignations.length > 1){
                $(this).attr("data-color", "#55ddff");
              } else if (daysleft > 1460) {
                $(this).attr("data-color", "#47702c");
              } else if (daysleft > 1095) {
                $(this).attr("data-color", "#5e943a");
              } else if (daysleft > 730) {
                $(this).attr("data-color", "#75b848");
              } else if (daysleft > 365) {
                $(this).attr("data-color", "#8bdb56");
              } else if (daysleft > 30) {
                $(this).attr("data-color", "#a2ff64");
              } else if (daysleft > -1) {
                $(this).attr("data-color", "#ffdd09");
              } else {
                $(this).attr("data-color", "#ff6464");
              }
            } else {
              $(this).attr("data-color", "#14d100");
            }
          } else {
            $(this).attr("data-color", "#fff");
          }
        } else {
          $(`[id^=nf_]`).css("opacity", "0");
          $(`[id^=nb_]`).css("opacity", "0");
          if (
            workplace.workplace_assignations !== undefined &&
            workplace.workplace_assignations.length > 0
          ) {
            $(this).attr("data-color", "#c4b7c8");
          } else {
            $(this).attr("data-color", "#fff");
          }
        }
        $(this).css("fill", $(this).attr("data-color"));
      });
      if (window.isAdmin) {
        $("#leyenda_admin").css("opacity", "1");
        $("[inkscape\\:label^=fechadecaducidad]").css("opacity", "1");
        $("[inkscape\\:label^=whobefore]").css("opacity", "1");
      } else {
        $("#leyenda_admin").css("opacity", "0");
        $("[inkscape\\:label^=fechadecaducidad]").css("opacity", "0");
        $("[inkscape\\:label^=whobefore]").css("opacity", "0");
      }
      window.hide_copy_buttons = this.hide_copy_buttons;
      this.initialize_copy_buttons();
      /* From URL */
      if (window.location.hash !== "") {
        $("#mesa_" + window.location.hash.substr(1)).click();
      }
      else{
        $("[id^=mesa]").attr("data-active", "false");
      }
    },

    handleKeyDown(e) {
      let code = e.charCode ? e.charCode : e.keyCode;
      let x, y;
      switch (code) {
        case 37: //left
          x = -2.5;
          y = 0;
          break;
        case 39: //right
          x = 2.5;
          y = 0;
          break;
        case 38: //up
          x = 0;
          y = -2.5;
          break;
        case 40: //down
          x = 0;
          y = 2.5;
          break;
        default:
          return;
      }
      let actobj = $("[data-active=true]");
      if (actobj.length == 0) return;
      let origx =
        $("[data-active=true]").position().left +
        $("[data-active=true]").attr("width") / 2;
      let origy =
        $("[data-active=true]").position().top -
        $(window).scrollTop() +
        $("[data-active=true]").attr("height") / 2;
      if (isNaN(origx) && isNaN(origy)) {
        origx = $("[data-active=true]").position().left + 10;
        origy =
          $("[data-active=true]").position().top - $(window).scrollTop() + 10;
      }
      let i = 0;
      let radarx, radary;
      const coneAngle = 15 * (Math.PI / 180); // 15 degrees in radians
      const stepSize = 5; // Step size for the lookup
      const maxDistance = 60; // Maximum distance to look

      for (let i = 0; i < maxDistance; i += stepSize) {
        origx += x * 2;
        origy += y * 2;

        // Check the center direction first
        let element = $(document)
          .get(0)
          .elementFromPoint(origx, origy);
        if (
          element != null &&
          $(element).attr("id").match(/^mesa_/) != null &&
          $(element).attr("id") != $(actobj).attr("id")
        ) {
          $(element).click();
          return;
        }

        // Check the sides within the cone
        for (let angle = -coneAngle; angle <= coneAngle; angle += coneAngle / 5) {
          let offsetX = i * Math.cos(angle);
          let offsetY = i * Math.sin(angle);

          if (x == 0) {
            radarx = offsetX;
            radary = 0;
          } else {
            radarx = 0;
            radary = offsetY;
          }

          element = $(document)
            .get(0)
            .elementFromPoint(origx + radarx, origy + radary);
          if (
            element != null &&
            $(element).attr("id").match(/^mesa_/) != null &&
            $(element).attr("id") != $(actobj).attr("id")
          ) {
            $(element).click();
            return;
          }
        }
      }
    },

    handleScroll() {
      if (this.scrollDatos != null) clearTimeout(this.scrollDatos);
      this.scrollDatos = window.setTimeout(function() {
        var finaldestination;
        var eloffset = $("svg").offset();
        var windowpos = $(window).scrollTop();
        if (windowpos + 70 < eloffset.top) {
          finaldestination = 0;
        } else {
          finaldestination = windowpos - 160;
        }
        if (finaldestination > $("svg").height() - 280) {
          finaldestination = $("svg").height() - 280;
        }
        $("#datos").attr("transform", "translate(0," + finaldestination + ")");
      }, 20);
    },

    fill_data(jqobj) {
      let id = $(jqobj)
        .attr("id")
        .replace(/mesa_/, "")
        .toLowerCase();
      let workplace = this.workplaces.find(
        workplace => workplace.place_code.toLowerCase().replace("-","_").replace("ñ","nh") === id
      );
      if(workplace == null) return;
      const workplaceAssignations = Array.isArray(workplace.workplace_assignations)
        ? workplace.workplace_assignations
        : [];
      const getAssignationName = assignation =>
        assignation.person.preferred_name.given_name +
        " " +
        assignation.person.preferred_name.family_name;
      const hiddenAssignationNames =
        workplaceAssignations.length > 3
          ? workplaceAssignations.slice(2).map(getAssignationName)
          : [];
      let persona_id =
        workplaceAssignations.length > 0
          ? workplaceAssignations[0].person.id
          : null;
      let persona2_id =
        workplaceAssignations.length > 1
          ? workplaceAssignations[1].person.id
          : null;
      let persona3_id =
        workplaceAssignations.length > 2
          ? workplaceAssignations[2].person.id
          : null;
      let nombre =
        workplaceAssignations.length > 0
          ? getAssignationName(workplaceAssignations[0])
          : null;
      let nombre2 =
        workplaceAssignations.length > 1
          ? getAssignationName(workplaceAssignations[1])
          : null;
      let nombre3 =
        workplaceAssignations.length > 2
          ? getAssignationName(workplaceAssignations[2])
          : null;
      if (hiddenAssignationNames.length > 0) {
        persona3_id = null;
        nombre3 = this.$t("building.moreAssignations", {
          count: hiddenAssignationNames.length
        });
      }
      let ip = workplace.host !== null ? workplace.host.ip : null;
      let mac = workplace.host !== null ? workplace.host.mac : null;
      let telefono = workplace.extension;
      let roseta = workplace.network_socket;
      let cajonera = workplace.file_cabinet;
      let fechadecaducidad =
        workplace.workplace_assignations !== undefined &&
        workplace.workplace_assignations.length > 0
          ? workplace.workplace_assignations[0].expiration_date
          : null;
      let foto =   workplace.workplace_assignations !== undefined &&
        workplace.workplace_assignations.length > 0 && workplace.workplace_assignations[0].person.account != null
         && workplace.workplace_assignations[0].person.account.picture_website != null
         && workplace.workplace_assignations[0].person.account.picture_website != "null"
          ? this.$store.state.endpoint + "/styledMedia/thumb/" + workplace.workplace_assignations[0].person.account.picture_website
          : null;
      let mesa = $(jqobj).attr("inkscape:label").replace(/mesa_/, "");
      // Make sure workplace.workplace_assignations_before is ordered desc by expiration_date
      if (workplace.workplace_assignations_before !== undefined && workplace.workplace_assignations_before.length > 1){
        workplace.workplace_assignations_before.sort((a, b) => {
          if (a.expiration_date < b.expiration_date) {
            return 1;
          }
          if (a.expiration_date > b.expiration_date) {
            return -1;
          }
          return 0;
        });
      }
      if (persona_id !== null && this.isAdmin) {
        nombre =
          "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" +
          persona_id) +
          "'>" +
          nombre +
          "</a>";
        if (ip !== null && ip !== "") {
          ip = "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/hosts/#" + ip) + "'>" + ip + "</a>";
        }
        mesa = "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/workplaces/#" + mesa.replace("_","-").replace("nh","%C3%B1")) + "'>" + mesa.replace("_","-").replace("nh","ñ") + "</a>";
      }
      nombre2 = persona2_id !== null && this.isAdmin
        ? "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + persona2_id) + "'>" + nombre2 + "</a>"
        : nombre2;
      nombre3 = persona3_id !== null && this.isAdmin
        ? "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + persona3_id) + "'>" + nombre3 + "</a>"
        : nombre3;
      if (nombre == null || nombre == "") nombre = " - ";
      if (nombre2 == null || nombre2 == "") nombre2 = " ";
      if (nombre3 == null || nombre3 == "") nombre3 = " ";
      let personabefore_id;
      let personabefore2_id;
      let personabefore3_id;
      let personabefore4_id;
      let personabefore5_id;
      let personabefore6_id;
      let nombrebefore;
      let nombrebefore2;
      let nombrebefore3;
      let nombrebefore4;
      let nombrebefore5;
      let nombrebefore6;
      if (this.isAdmin){
        personabefore_id =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 0
            ? workplace.workplace_assignations_before[0].person.id
            : null;
        personabefore2_id =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 1
            ? workplace.workplace_assignations_before[1].person.id
            : null;
        personabefore3_id =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 2
            ? workplace.workplace_assignations_before[2].person.id
            : null;
        personabefore4_id =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 3
            ? workplace.workplace_assignations_before[3].person.id
            : null;
        personabefore5_id =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 4
            ? workplace.workplace_assignations_before[4].person.id
            : null;
        personabefore6_id =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 5
            ? workplace.workplace_assignations_before[5].person.id
            : null;
        nombrebefore =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 0
            ? workplace.workplace_assignations_before[0].person.preferred_name
                .given_name +
              " " +
              workplace.workplace_assignations_before[0].person.preferred_name
                .family_name
            : null;
        nombrebefore2 =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 1
            ? workplace.workplace_assignations_before[1].person.preferred_name
                .given_name +
              " " +
              workplace.workplace_assignations_before[1].person.preferred_name
                .family_name
            : null;
        nombrebefore3 =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 2
            ? workplace.workplace_assignations_before[2].person.preferred_name
                .given_name +
              " " +
              workplace.workplace_assignations_before[2].person.preferred_name
                .family_name
            : null;
        nombrebefore4 =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 3
            ? workplace.workplace_assignations_before[3].person.preferred_name
                .given_name +
              " " +
              workplace.workplace_assignations_before[3].person.preferred_name
                .family_name
            : null;
        nombrebefore5 =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 4
            ? workplace.workplace_assignations_before[4].person.preferred_name
                .given_name +
              " " +
              workplace.workplace_assignations_before[4].person.preferred_name
                .family_name
            : null;
        nombrebefore6 =
          workplace.workplace_assignations_before !== undefined &&
          workplace.workplace_assignations_before.length > 5
            ? workplace.workplace_assignations_before[5].person.preferred_name
                .given_name +
              " " +
              workplace.workplace_assignations_before[5].person.preferred_name
                .family_name
            : null;
        if (personabefore_id !== null) {
          nombrebefore =
            "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + personabefore_id) + "'>" + nombrebefore + "</a>";
        }
        nombrebefore2 = personabefore2_id !== null
          ? "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + personabefore2_id) + "'>" + nombrebefore2 + "</a>"
          : '';
        nombrebefore3 = personabefore3_id !== null
          ? "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + personabefore3_id) + "'>" + nombrebefore3 + "</a>"
          : '';
        nombrebefore4 = personabefore4_id !== null
          ? "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + personabefore4_id) + "'>" + nombrebefore4 + "</a>"
          : '';
        nombrebefore5 = personabefore5_id !== null
          ? "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + personabefore5_id) + "'>" + nombrebefore5 + "</a>"
          : '';
        nombrebefore6 = personabefore6_id !== null
          ? "<a text-decoration=\"underline\" xlink:href='" + this.appPath("manage/edit/researchers/edit/" + personabefore6_id) + "'>" + nombrebefore6 + "</a>"
          : '';
        if (nombrebefore == null || nombrebefore == "") nombrebefore = " - ";
        if (nombrebefore2 == null || nombrebefore2 == "") nombrebefore2 = " ";
        if (nombrebefore3 == null || nombrebefore3 == "") nombrebefore3 = " ";
        if (nombrebefore4 == null || nombrebefore4 == "") nombrebefore4 = " ";
        if (nombrebefore5 == null || nombrebefore5 == "") nombrebefore5 = " ";
        if (nombrebefore6 == null || nombrebefore6 == "") nombrebefore6 = " ";
      }
      if (ip == null || ip == "") ip = " - ";
      if (mac == null || mac == "") mac = " - ";
      if (telefono == null || telefono == "") telefono = " - ";
      if (roseta == null || roseta == "") roseta = " - ";
      if (cajonera == null || cajonera == "") cajonera = " - ";
      if (fechadecaducidad == null || fechadecaducidad == "")
        fechadecaducidad = " - ";
      if (foto == null || foto == "") $("#foto").css("opacity", "0");
      else {
        $("#foto").css("opacity", "1");
        $("#foto").attr(
          "xlink:href",
          foto
        );
      }
      $("#who tspan")
        .css("visibility", "visible")
        .html(nombre);
      $("#who2 tspan")
        .css("visibility", "visible")
        .html(nombre2);
      $("#who3 tspan")
        .css("visibility", "visible")
        .html(nombre3);
      this.setWho3Tooltip(hiddenAssignationNames);
      if(this.isAdmin){
        $("#whobefore tspan")
          .css("visibility", "visible")
          .html(nombrebefore);
        $("#whobefore2 tspan")
          .css("visibility", "visible")
          .html(nombrebefore2);
        $("#whobefore3 tspan")
          .css("visibility", "visible")
          .html(nombrebefore3);
        $("#whobefore4 tspan")
          .css("visibility", "visible")
          .html(nombrebefore4);
        $("#whobefore5 tspan")
          .css("visibility", "visible")
          .html(nombrebefore5);
        $("#whobefore6 tspan")
          .css("visibility", "visible")
          .html(nombrebefore6);
      }
      $("[inkscape\\:label=where] tspan")
        .css("visibility", "visible")
        .html(mesa);
      $("[inkscape\\:label=roseta] tspan")
        .css("visibility", "visible")
        .text(roseta);
      $("[inkscape\\:label=cajonera] tspan")
        .css("visibility", "visible")
        .text(cajonera);
      $("[inkscape\\:label=ip] tspan")
        .css("visibility", "visible")
        .html(ip);
      $("[inkscape\\:label=mac] tspan")
        .css("visibility", "visible")
        .text(mac);
      $("[inkscape\\:label=telefono] tspan")
        .css("visibility", "visible")
        .text(telefono);
      $("[inkscape\\:label=fechadecaducidad]")
        .css("visibility", "visible")
        .text(fechadecaducidad);
      this.update_copy_buttons();
      $("#placeholder,#placeholder_text,#placeholder_rect").css(
        "visibility",
        "hidden"
      );
    },

    setWho3Tooltip(names) {
      const who3 = $("#who3");
      who3.find("title").remove();
      who3.css("cursor", names.length > 0 ? "help" : "default");
      if (names.length === 0 || !who3.length) {
        return;
      }
      const title = document.createElementNS("http://www.w3.org/2000/svg", "title");
      title.textContent = names.join("\n");
      who3[0].insertBefore(title, who3[0].firstChild);
    },

    initialize_copy_buttons() {
      const copyButtons = $("[id^=copy_]");
      copyButtons.find("rect").css({
        "fill-opacity": "0",
        stroke: "none",
        "pointer-events": "all"
      });
      copyButtons.find("path").css({
        fill: "none",
        stroke: "#666666",
        "stroke-width": "1.1",
        "pointer-events": "none"
      });
      copyButtons
        .off("click")
        .on("click", event => {
          event.stopPropagation();
          this.copy_plan_field($(event.currentTarget).attr("data-copy-field"), event);
        });
      this.hide_copy_buttons();
    },

    hide_copy_buttons() {
      $("[id^=copy_]").css("opacity", "0");
      this.hide_copy_feedback();
    },

    update_copy_buttons() {
      ["where", "roseta", "cajonera", "ip", "telefono", "mac"].forEach(field => {
        const textNode = $(`[inkscape\\:label=${field}]`)[0];
        const button = $(`#copy_${field}`);
        const value = this.copyable_plan_field_text(field);
        if (!textNode || !button.length || !value) {
          button.css("opacity", "0");
          return;
        }
        const box = textNode.getBBox();
        const xOffset = field === "mac" ? 11 : 6;
        const maxX = field === "mac" ? 917 : 912;
        const x = Math.min(box.x + box.width + xOffset, maxX);
        const y = box.y + box.height / 2 - 7;
        button
          .attr("transform", `translate(${x},${y})`)
          .css("opacity", "1");
      });
    },

    copyable_plan_field_text(field) {
      const value = $(`[inkscape\\:label=${field}]`).text().trim();
      return value && value !== "-" ? value : "";
    },

    copy_plan_field(field, event) {
      const value = this.copyable_plan_field_text(field);
      if (!value) return;
      this.copy_text_to_clipboard(value).then(() => this.show_copy_feedback(event));
    },

    copy_text_to_clipboard(value) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(value);
      }
      const input = document.createElement("textarea");
      input.value = value;
      input.setAttribute("readonly", "readonly");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      return Promise.resolve();
    },

    show_copy_feedback(event) {
      const tooltip = this.get_copy_feedback();
      if (!tooltip) return;
      const containerBox = this.$el.getBoundingClientRect();
      const tooltipBox = tooltip.getBoundingClientRect();
      const x = Math.min(
        Math.max(event.clientX - containerBox.left + 12, 4),
        this.$el.clientWidth - tooltipBox.width - 4
      );
      const y = Math.max(event.clientY - containerBox.top - tooltipBox.height - 8, 4);
      $(tooltip)
        .css({ left: `${x}px`, top: `${y}px` })
        .css("opacity", "1");
      clearTimeout(this.copyFeedbackTimeout);
      this.copyFeedbackTimeout = setTimeout(() => this.hide_copy_feedback(), 1600);
    },

    hide_copy_feedback() {
      $("#clipboard_feedback").css("opacity", "0");
    },

    get_copy_feedback() {
      const existingTooltip = $("#clipboard_feedback")[0];
      if (existingTooltip) return existingTooltip;
      const tooltip = document.createElement("div");
      tooltip.setAttribute("id", "clipboard_feedback");
      tooltip.setAttribute(
        "style",
        "position:absolute;left:0;top:0;opacity:0;pointer-events:none;background:#333333;color:#ffffff;border-radius:3px;padding:4px 8px;font:11px Arial;white-space:nowrap;z-index:5"
      );
      tooltip.textContent = "Copiado al portapapeles";
      this.$el.appendChild(tooltip);
      return tooltip;
    },

    appPath(path) {
      const base = this.$router.options.base || "/";
      const normalizedBase = base === "/" ? "" : base.replace(/\/$/, "");
      return `${normalizedBase}/${path.replace(/^\//, "")}`;
    }
  }
};
</script>

<style scoped></style>
